export const send = (id, method) => {
  let url
  let post = true

  switch (method) {
    case "add":
      url = "/ajax/compare/add"
      break
    case "delete":
      url = "/ajax/compare/delete"
      break
    case "clean":
      url = "/ajax/compare/clean"
      break
    case "get":
      url = "/ajax/compare/get"
      post = false
      break
    default:
      url = "/ajax/basket/add"
      break
  }

  const options = {
    method: post ? "POST" : "GET",
    credentials: "include",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json"
    },
    ...(post
      ? {
          body: JSON.stringify({
            id: id
          })
        }
      : null)
  }

  return fetch(url, options).then(res => res.json())
}
